import React, { FC } from "react";
import { Button, ButtonProps, PolymorphicComponentProps } from "@mantine/core";
import styles from "@/PageComponents/Button/ChipButton.module.css";

/* One look for the quick "add" buttons across the job overview sections. */
const ChipButton: FC<Omit<PolymorphicComponentProps<'button', ButtonProps>, 'variant' | 'size' | 'h' | 'px'>> = ({ className, ...props }) =>
    <Button type={'button'} variant={'default'} size={'sm'} h={32} px={12} className={`${styles.chip} ${className ?? ''}`} {...props} />;

export default ChipButton;
